import styled from "styled-components";

export const BackGroundContainer = styled.div`
  position: relative;
  min-width: 324px;
  min-height: 100vh;
  height: 100%;
  width: 15%;
  overflow-y: scroll;
  background-color: ${props => props.theme.white4};
`;

export const MenuContainer = styled.div`
  margin: 20px;
  position: relative;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${props => props.theme.white2};
  height: calc(100vh - 40px);
  min-height: 750px;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1); /* 그림자 설정 */
  border-radius: 20px;
`;

export const HeaderContainer = styled.div`
  margin: 20px;
  width: calc(100% - 40px);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
  img {
    margin-right: 10px;
  }
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 10px 0;
`;

export const SelectContainer = styled.div`
  padding: 10px 0;
  display: flex;
  font-size: 20px;
  flex-direction: column;
  width: 100%;
  font-weight: 500;
  h4 {
    display: flex;
    width: 100%;
    justify-content: center;
    font-weight: 700;
  }
  span {
    border-radius: 14px;
    margin: 5px 10px;
    cursor: pointer;
    padding: 10px 5px 10px 30px;
    display: flex;
    align-items: center; /* 세로 축으로 중앙 정렬 */
    height: 100%; /* 부모 컨테이너의 높이에 맞춤 */
    transition: 0.4s;
  }
  span:hover {
    background-color: ${props => props.theme.white4};
  }
  img {
    margin-right: 10px;
  }
`;

export const ChangePasswordContainer = styled.div`
  background-color: ${props => props.theme.white3};
  height: 120px;
  border-radius: 0 0 20px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: 500;
  cursor: pointer;
  span {
    margin: 5px 0;
    padding: 5px 20px;
    display: flex;
    border-radius: 10px;
    transition: 0.4s;
  }
  span:hover {
    background-color: ${props => props.theme.white4};
  }
`;

export const FooterContainer = styled.div`
  width: 100%;
  position: absolute;
  text-align: center;
  bottom: 0;
  img {
    margin-right: 10px;
  }
`;
